module.exports = __webpack_public_path__ + "img/icon_证书_A级赛事@3x.b2829a35.png";